import * as React from 'react';
import { Datagrid, List, TextField } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { IndexField } from '../../components/IndexField';
import { ListActions } from '../../components/ListAction';
import { ListIsEmptyPage } from '../../components/ListIsEmptyPage';

export const LocationList = (props: unknown) => (
  <List sort={{ field: 'order', order: 'ASC' }} empty={<ListIsEmptyPage />} actions={<ListActions />} title={<CustomTitle />} {...props}>
    <Datagrid rowClick="edit">
      <IndexField label="#" sortable={false} />
      <TextField source="title" />
      <TextField source="direction" />
      <TextField source="order" />
      <TextField source="id" />
    </Datagrid>
  </List>
);
